var _rect, _rect2, _rect3, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalLayoutNav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "none",
    stroke: "#c9c9c9",
    strokeWidth: 1.6,
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 10.6,
    width: 8.8,
    height: 8.8,
    rx: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6,
    y: 1.6,
    width: 8.8,
    height: 8.8,
    rx: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6,
    y: 19.6,
    width: 8.8,
    height: 8.8,
    rx: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 15H15M15 6H19.6M15 6V24M15 24H19.6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalLayoutNav);
export default __webpack_public_path__ + "static/media/signal-layout-nav.7d62cde6f36d06e8bd9878f6f31c0089.svg";
export { ForwardRef as ReactComponent };